import { IApiClient } from '../ApiClient';
import { LoadBalancer } from '../ApiModel';
import { loadAllItems } from '../helper/PagingHelper';
import { IdResourceCollectionStore } from './ResourceCollectionStore';
import { ResourceSession } from './ResourceSession';

export default class LoadBalancersStore extends IdResourceCollectionStore<LoadBalancer> {
    constructor(apiClient: IApiClient, session?: ResourceSession<LoadBalancer>) {
        super({
            getItems: () => loadAllItems((link) => apiClient.getLoadBalancers(link)),
            session: session,
        });
    }
}
